import React from 'react'
import { cn } from '@stratascratch/ui'
import { root } from './container.module.css'

interface Props {
  children?: React.ReactNode
  extraClass?: string
}

function Container({ children, extraClass }: Props) {
  return <div className={cn(root, extraClass)}>{children}</div>
}

Container.defaultProps = {
  children: null,
  extraClass: '',
}

export default Container
